if (document.documentElement.lang.split('-')[0] === 'hu') {
/* Curated set defaults; estimates never change Shopify prices. */
(function () {
  'use strict';
  if (customElements.get('pb-cro-set')) return;
  class ProductSet extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-info');
      this.button = this.querySelector('[data-set-add]');
      this.message = this.querySelector('[data-set-message]');
      const extrasHeading = this.querySelector('.pb-cro-set__extras-heading');
      if (extrasHeading) extrasHeading.textContent = '2. Válaszd ki a további termékeket';
      this.mainVariants = new Map(JSON.parse(this.querySelector('[data-set-main-variants]').textContent).map(v => [String(v.id), v]));
      this.onSelection = () => this.update();
      this.initialiseCompanions();
      this.onChange = event => {
        if (event.target.matches('[data-set-variant]')) {
          const row = event.target.closest('[data-set-item]');
          row.dataset.userVariant = 'true';
          const quantity = row.querySelector('[data-set-qty]');
          quantity.dataset.variant = '';
          const v = this.companion(row);
          const check = row.querySelector('[data-set-check]');
          check.disabled = !v.available;
          if (check.disabled) check.checked = false;
          row.querySelector('[data-set-stock]').textContent = v.available ? 'Készleten' : 'Elfogyott';
          row.classList.toggle('is-unavailable', !v.available);
          this.renderPrice(row.querySelector('[data-set-price]'), v.price, v.compare, /\b\d+\s*(buc|perechi)\b/i.test(row.dataset.title || '') ? '/ csomag' : '/ db');
        }
        this.update();
      };
      this.scope?.addEventListener('pb-cro:selection', this.onSelection);
      this.scope?.addEventListener('change', this.onChange);
      this.scope?.addEventListener('input', this.onSelection);
      this.variantEvent = `eurus:product-page-variant-select:updated:${this.dataset.section}`;
      document.addEventListener(this.variantEvent, this.onSelection);
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('pb-cro:selection', this.onSelection);
      this.scope?.removeEventListener('change', this.onChange);
      this.scope?.removeEventListener('input', this.onSelection);
      document.removeEventListener(this.variantEvent, this.onSelection);
    }
    money(n) { return this.dataset.currency === 'RON' ? new Intl.NumberFormat('hu-HU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n / 100) + ' lei' : new Intl.NumberFormat('hu-HU', { style: 'currency', currency: this.dataset.currency || 'RON' }).format(n / 100); }
    renderPrice(target, price, compare, unitLabel) {
      target.replaceChildren();
      target.classList.add('pb-cro-set__line-price');
      const discounted = Number.isFinite(compare) && compare > price && price >= 0;
      if (discounted) {
        const old = document.createElement('s');
        old.className = 'pb-cro-set__old-price';
        old.setAttribute('aria-label', 'Eredeti ár');
        old.textContent = this.money(compare); target.append(old);
      }
      const current = document.createElement('strong');
      current.className = discounted ? 'pb-cro-set__sale-price' : '';
      current.textContent = this.money(price); target.append(current);
      if (discounted) {
        const percent = document.createElement('span');
        percent.className = 'pb-cro-set__discount-badge';
        percent.textContent = `−${new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 1 }).format((compare - price) / compare * 100)}%`;
        const saving = document.createElement('small');
        saving.className = 'pb-cro-set__line-saving';
        saving.textContent = `Megtakarítás: ${this.money(compare - price)} ${unitLabel}`;
        target.append(percent, saving);
      }
    }
    // Explicit units only: shade codes such as 6.60 are not quantities.
    size(text) {
      const m = String(text || '').toLowerCase().match(/(\d+(?:[.,]\d+)?)\s*(ml|kg|g|l)\b/);
      return m ? { amount: Number(m[1].replace(',', '.')) * (['l','kg'].includes(m[2]) ? 1000 : 1), unit: ['ml','l'].includes(m[2]) ? 'volume' : 'mass' } : null;
    }
    initialiseCompanions() {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const main = this.mainVariants.get(String(form?.querySelector('[name="id"]')?.value));
      const target = this.size(main?.title) || this.size(this.dataset.mainTitle);
      for (const row of this.querySelectorAll('[data-set-item]')) {
        const field = row.querySelector('select[data-set-variant]');
        if (field && !row.dataset.userVariant) {
          const options = [...field.options].filter(o => o.value && o.dataset.available === 'true');
          let choice = options[0];
          if (row.dataset.kind === 'oxidant') {
            const sized = options.map(o => ({o, size:this.size(o.dataset.title || o.textContent)})).filter(x => x.size);
            const match = target && sized.find(x => x.size.unit === target.unit && x.size.amount === target.amount);
            const comparable = sized.filter(x => x.size.unit === (target?.unit || sized[0]?.size.unit));
            choice = match?.o || comparable.sort((a,b) => a.size.amount-b.size.amount)[0]?.o || choice;
          }
          field.value = choice?.value || '';
        }
        const quantity = row.querySelector('[data-set-qty]');
        const variantField = row.querySelector('[data-set-variant]');
        const option = variantField.selectedOptions ? variantField.selectedOptions[0] : variantField;
        if (quantity.dataset.variant !== variantField.value) {
          quantity.value = option.dataset.min || '1';
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          quantity.max = option.dataset.max || '';
          quantity.dataset.variant = variantField.value;
        }
        const v = this.companion(row), check = row.querySelector('[data-set-check]');
        const variantName = row.querySelector('[data-set-variant-name]');
        if (variantName) variantName.textContent = option.dataset.title && !/^(default|default title)$/i.test(option.dataset.title) ? option.dataset.title : '';
        quantity.disabled = !v.available;
        row.classList.toggle('is-selected', check.checked);
        check.disabled = !v.available;
        if (!v.available) check.checked = false;
        row.classList.toggle('is-unavailable', !v.available);
        row.querySelector('[data-set-stock]').textContent = v.available ? 'Készleten' : 'Elfogyott';
        this.renderPrice(row.querySelector('[data-set-price]'), v.price, v.compare, /\b\d+\s*(buc|perechi)\b/i.test(row.dataset.title || '') ? '/ csomag' : '/ db');
      }
    }
    companion(row) {
      const field = row.querySelector('[data-set-variant]');
      const v = field.selectedOptions ? field.selectedOptions[0] : field;
      return { id: field.value, price: Number(v.dataset.price || 0), compare: Math.max(Number(v.dataset.price || 0), Number(v.dataset.compare || 0)), kind: row.dataset.kind, qty: Number(row.querySelector('[data-set-qty]').value), validQuantity: row.querySelector('[data-set-qty]').checkValidity() && Number.isSafeInteger(Number(row.querySelector('[data-set-qty]').value)) && Number(row.querySelector('[data-set-qty]').value) > 0, available: !!field.value && v.dataset.available === 'true' };
    }
    selection() {
      const shades = this.scope?.querySelector('pb-card-shades[data-mode="pdp"]');
      const main = new Map();
      let valid = true, total = 0, list = 0;
      if (shades) {
        valid = !shades.busy && !shades.uncertain;
        for (const [id, qty] of shades.committed || []) {
          const v = shades.variants.get(id) || this.mainVariants.get(String(id));
          if (!v?.available || !Number.isSafeInteger(qty) || qty < 1) valid = false;
          main.set(id, qty); total += (v?.price || 0) * qty; list += Math.max(v?.price || 0, this.mainVariants.get(String(id))?.compare || 0) * qty;
        }
      } else {
        const form = document.getElementById(`product-form-${this.dataset.section}`);
        const id = form?.querySelector('[name="id"]')?.value;
        const v = this.mainVariants.get(String(id));
        const qty = Number(this.scope?.querySelector('[name="quantity"]')?.value || 1);
        valid = !!v?.available && Number.isSafeInteger(qty) && qty >= v.min && (qty - v.min) % v.step === 0;
        if (valid) { main.set(String(id), qty); total += v.price * qty; list += Math.max(v.price, v.compare || 0) * qty; }
      }
      const extras = new Map(), extraRows = [];
      for (const row of this.querySelectorAll('[data-set-item]')) {
        if (!row.querySelector('[data-set-check]').checked) continue;
        const v = this.companion(row);
        if (!v.available) continue;
        if (!v.validQuantity) { valid = false; continue; }
        extras.set(v.id, (extras.get(v.id) || 0) + v.qty); total += v.price * v.qty; list += v.compare * v.qty; extraRows.push(v);
      }
      const count = [...main.values(), ...extras.values()].reduce((n,q) => n+q, 0);
      const mainCount = [...main.values()].reduce((n,q) => n+q, 0);
      const extrasTotal = extraRows.reduce((sum, v) => sum + v.price * v.qty, 0);
      return { shades, main, extras, total, list, mainÖsszesen: total - extrasTotal, extrasTotal, count, mainCount, valid: valid && main.size > 0 };
    }
    update() {
      this.initialiseCompanions();
      const s = this.selection();
      this.button.disabled = !s.valid || !!this.busy || !!this.locked || (!!s.shades && !s.extras.size);
      this.button.textContent = this.busy ? 'Hozzáadás…' : 'Kiegészítők hozzáadása a kosárhoz';
      if (this.busy) this.button.textContent = 'Hozzáadás…';
      this.button.setAttribute('aria-busy', String(!!this.busy));
      const lines = this.querySelector('[data-set-main-lines]');
      lines.replaceChildren();
      for (const [id, qty] of s.main) {
        const v = this.mainVariants.get(String(id));
        const li = document.createElement('li');
        const title = document.createElement('span');
        title.textContent = `${qty} × ${!v?.title || /^(default|default title)$/i.test(v.title) ? 'A kiválasztott termék' : v.title}`;
        const amount = document.createElement('div');
        this.renderPrice(amount, (v?.price || 0) * qty, Math.max(v?.price || 0, v?.compare || 0) * qty, qty > 1 ? `${qty} db esetén` : '/ db');
        li.append(title, amount); lines.append(li);
      }
      if (!s.main.size) {
        const li = document.createElement('li'); li.textContent = 'Válaszd ki fent az árnyalatot és a mennyiséget.'; lines.append(li);
      }
      this.querySelector('[data-set-total]').textContent = s.valid ? (s.shades && !s.extras.size ? 'Az árnyalatok már a kosárban vannak. Válassz opcionális terméket, vagy fejezd be a rendelést.' : `${s.count} db kiválasztva`) : 'Először add hozzá az árnyalatokat, és ellenőrizd a készletet.';
      this.querySelector('[data-set-main-total]').textContent = s.valid ? this.money(s.mainTotal) : '—';
      this.querySelector('[data-set-extras-total]').textContent = s.valid ? this.money(s.extrasTotal) : '—';
      this.querySelector('[data-set-grand-total]').textContent = s.valid ? this.money(s.total) : '—';
      const saving = Math.max(0, s.list - s.total);
      const showSaving = s.valid && s.list > 0 && saving > 0;
      for (const el of this.querySelectorAll('[data-set-savings-row]')) el.hidden = !showSaving;
      const reference = this.querySelector('[data-set-reference]');
      const reduction = this.querySelector('[data-set-product-saving]');
      if (reference) reference.textContent = showSaving ? this.money(s.list) : '';
      if (reduction) reduction.textContent = showSaving ? `−${this.money(saving)} (−${new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 1 }).format(saving / s.list * 100)}%)` : '';

    }

    async add() {
      const s = this.selection();
      if (!s.valid || this.busy || this.locked) return;
      if (!window.PBCroCart) { this.message.textContent = 'A kosár most nem érhető el. Töltsd újra az oldalt.'; return; }
      this.busy = true; this.update();
      let result;
      try {
        if (s.shades) result = await window.PBCroCart.add(s.extras);
        else {
          const items = new Map(s.main);
          for (const [id, qty] of s.extras) items.set(id, (items.get(id) || 0) + qty);
          result = await window.PBCroCart.add(items);
        }
        if (result?.complete) {
          window.PBCroAnalytics?.emit('set_add', { product_id: this.dataset.product, items_added: [...s.main.values(), ...s.extras.values()].reduce((n,q)=>n+q,0), value: s.total / 100 });
          this.message.textContent = 'A kiválasztott termékek a kosárba kerültek.';
        } else {
          // A partially accepted request must never be submitted as the whole set again.
          this.locked = true;
          this.message.textContent = result?.unavailable ? 'A kosár most nem érhető el. Töltsd újra az oldalt.' : 'A teljes szett hozzáadását nem sikerült megerősíteni. Ellenőrizd a kosarat és töltsd újra az oldalt, mielőtt ismét próbálkozol.';
        }
      } catch (_) {
        this.locked = true;
        this.message.textContent = 'Újabb próbálkozás előtt ellenőrizd a kosarat és töltsd újra az oldalt.';
      }
      this.busy = false; this.update();
    }
  }
  customElements.define('pb-cro-set', ProductSet);
})();

} else {
/* Curated set defaults; estimates never change Shopify prices. */
(function () {
  'use strict';
  if (customElements.get('pb-cro-set')) return;
  class ProductSet extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-info');
      this.button = this.querySelector('[data-set-add]');
      this.message = this.querySelector('[data-set-message]');
      const extrasHeading = this.querySelector('.pb-cro-set__extras-heading');
      if (extrasHeading) extrasHeading.textContent = '2. Alege produsele opționale';
      this.mainVariants = new Map(JSON.parse(this.querySelector('[data-set-main-variants]').textContent).map(v => [String(v.id), v]));
      this.onSelection = () => this.update();
      this.initialiseCompanions();
      this.onChange = event => {
        if (event.target.matches('[data-set-variant]')) {
          const row = event.target.closest('[data-set-item]');
          row.dataset.userVariant = 'true';
          const quantity = row.querySelector('[data-set-qty]');
          quantity.dataset.variant = '';
          const v = this.companion(row);
          const check = row.querySelector('[data-set-check]');
          check.disabled = !v.available;
          if (check.disabled) check.checked = false;
          row.querySelector('[data-set-stock]').textContent = v.available ? 'În stoc' : 'Stoc epuizat';
          row.classList.toggle('is-unavailable', !v.available);
          this.renderPrice(row.querySelector('[data-set-price]'), v.price, v.compare, /\b\d+\s*(buc|perechi)\b/i.test(row.dataset.title || '') ? '/ pachet' : '/ buc.');
        }
        this.update();
      };
      this.scope?.addEventListener('pb-cro:selection', this.onSelection);
      this.scope?.addEventListener('change', this.onChange);
      this.scope?.addEventListener('input', this.onSelection);
      this.variantEvent = `eurus:product-page-variant-select:updated:${this.dataset.section}`;
      document.addEventListener(this.variantEvent, this.onSelection);
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('pb-cro:selection', this.onSelection);
      this.scope?.removeEventListener('change', this.onChange);
      this.scope?.removeEventListener('input', this.onSelection);
      document.removeEventListener(this.variantEvent, this.onSelection);
    }
    money(n) { return this.dataset.currency === 'RON' ? new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n / 100) + ' lei' : new Intl.NumberFormat('ro-RO', { style: 'currency', currency: this.dataset.currency || 'RON' }).format(n / 100); }
    renderPrice(target, price, compare, unitLabel) {
      target.replaceChildren();
      target.classList.add('pb-cro-set__line-price');
      const discounted = Number.isFinite(compare) && compare > price && price >= 0;
      if (discounted) {
        const old = document.createElement('s');
        old.className = 'pb-cro-set__old-price';
        old.setAttribute('aria-label', 'Preț de listă');
        old.textContent = this.money(compare); target.append(old);
      }
      const current = document.createElement('strong');
      current.className = discounted ? 'pb-cro-set__sale-price' : '';
      current.textContent = this.money(price); target.append(current);
      if (discounted) {
        const percent = document.createElement('span');
        percent.className = 'pb-cro-set__discount-badge';
        percent.textContent = `−${new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 1 }).format((compare - price) / compare * 100)}%`;
        const saving = document.createElement('small');
        saving.className = 'pb-cro-set__line-saving';
        saving.textContent = `Economisești ${this.money(compare - price)} ${unitLabel}`;
        target.append(percent, saving);
      }
    }
    // Explicit units only: shade codes such as 6.60 are not quantities.
    size(text) {
      const m = String(text || '').toLowerCase().match(/(\d+(?:[.,]\d+)?)\s*(ml|kg|g|l)\b/);
      return m ? { amount: Number(m[1].replace(',', '.')) * (['l','kg'].includes(m[2]) ? 1000 : 1), unit: ['ml','l'].includes(m[2]) ? 'volume' : 'mass' } : null;
    }
    initialiseCompanions() {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const main = this.mainVariants.get(String(form?.querySelector('[name="id"]')?.value));
      const target = this.size(main?.title) || this.size(this.dataset.mainTitle);
      for (const row of this.querySelectorAll('[data-set-item]')) {
        const field = row.querySelector('select[data-set-variant]');
        if (field && !row.dataset.userVariant) {
          const options = [...field.options].filter(o => o.value && o.dataset.available === 'true');
          let choice = options[0];
          if (row.dataset.kind === 'oxidant') {
            const sized = options.map(o => ({o, size:this.size(o.dataset.title || o.textContent)})).filter(x => x.size);
            const match = target && sized.find(x => x.size.unit === target.unit && x.size.amount === target.amount);
            const comparable = sized.filter(x => x.size.unit === (target?.unit || sized[0]?.size.unit));
            choice = match?.o || comparable.sort((a,b) => a.size.amount-b.size.amount)[0]?.o || choice;
          }
          field.value = choice?.value || '';
        }
        const quantity = row.querySelector('[data-set-qty]');
        const variantField = row.querySelector('[data-set-variant]');
        const option = variantField.selectedOptions ? variantField.selectedOptions[0] : variantField;
        if (quantity.dataset.variant !== variantField.value) {
          quantity.value = option.dataset.min || '1';
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          quantity.max = option.dataset.max || '';
          quantity.dataset.variant = variantField.value;
        }
        const v = this.companion(row), check = row.querySelector('[data-set-check]');
        const variantName = row.querySelector('[data-set-variant-name]');
        if (variantName) variantName.textContent = option.dataset.title && !/^(default|default title)$/i.test(option.dataset.title) ? option.dataset.title : '';
        quantity.disabled = !v.available;
        row.classList.toggle('is-selected', check.checked);
        check.disabled = !v.available;
        if (!v.available) check.checked = false;
        row.classList.toggle('is-unavailable', !v.available);
        row.querySelector('[data-set-stock]').textContent = v.available ? 'În stoc' : 'Stoc epuizat';
        this.renderPrice(row.querySelector('[data-set-price]'), v.price, v.compare, /\b\d+\s*(buc|perechi)\b/i.test(row.dataset.title || '') ? '/ pachet' : '/ buc.');
      }
    }
    companion(row) {
      const field = row.querySelector('[data-set-variant]');
      const v = field.selectedOptions ? field.selectedOptions[0] : field;
      return { id: field.value, price: Number(v.dataset.price || 0), compare: Math.max(Number(v.dataset.price || 0), Number(v.dataset.compare || 0)), kind: row.dataset.kind, qty: Number(row.querySelector('[data-set-qty]').value), validQuantity: row.querySelector('[data-set-qty]').checkValidity() && Number.isSafeInteger(Number(row.querySelector('[data-set-qty]').value)) && Number(row.querySelector('[data-set-qty]').value) > 0, available: !!field.value && v.dataset.available === 'true' };
    }
    selection() {
      const shades = this.scope?.querySelector('pb-card-shades[data-mode="pdp"]');
      const main = new Map();
      let valid = true, total = 0, list = 0;
      if (shades) {
        valid = !shades.busy && !shades.uncertain;
        for (const [id, qty] of shades.committed || []) {
          const v = shades.variants.get(id) || this.mainVariants.get(String(id));
          if (!v?.available || !Number.isSafeInteger(qty) || qty < 1) valid = false;
          main.set(id, qty); total += (v?.price || 0) * qty; list += Math.max(v?.price || 0, this.mainVariants.get(String(id))?.compare || 0) * qty;
        }
      } else {
        const form = document.getElementById(`product-form-${this.dataset.section}`);
        const id = form?.querySelector('[name="id"]')?.value;
        const v = this.mainVariants.get(String(id));
        const qty = Number(this.scope?.querySelector('[name="quantity"]')?.value || 1);
        valid = !!v?.available && Number.isSafeInteger(qty) && qty >= v.min && (qty - v.min) % v.step === 0;
        if (valid) { main.set(String(id), qty); total += v.price * qty; list += Math.max(v.price, v.compare || 0) * qty; }
      }
      const extras = new Map(), extraRows = [];
      for (const row of this.querySelectorAll('[data-set-item]')) {
        if (!row.querySelector('[data-set-check]').checked) continue;
        const v = this.companion(row);
        if (!v.available) continue;
        if (!v.validQuantity) { valid = false; continue; }
        extras.set(v.id, (extras.get(v.id) || 0) + v.qty); total += v.price * v.qty; list += v.compare * v.qty; extraRows.push(v);
      }
      const count = [...main.values(), ...extras.values()].reduce((n,q) => n+q, 0);
      const mainCount = [...main.values()].reduce((n,q) => n+q, 0);
      const extrasTotal = extraRows.reduce((sum, v) => sum + v.price * v.qty, 0);
      return { shades, main, extras, total, list, mainTotal: total - extrasTotal, extrasTotal, count, mainCount, valid: valid && main.size > 0 };
    }
    update() {
      this.initialiseCompanions();
      const s = this.selection();
      this.button.disabled = !s.valid || !!this.busy || !!this.locked || (!!s.shades && !s.extras.size);
      this.button.textContent = this.busy ? 'Se adaugă…' : 'Adaugă produsele opționale în coș';
      if (this.busy) this.button.textContent = 'Se adaugă…';
      this.button.setAttribute('aria-busy', String(!!this.busy));
      const lines = this.querySelector('[data-set-main-lines]');
      lines.replaceChildren();
      for (const [id, qty] of s.main) {
        const v = this.mainVariants.get(String(id));
        const li = document.createElement('li');
        const title = document.createElement('span');
        title.textContent = `${qty} × ${!v?.title || /^(default|default title)$/i.test(v.title) ? 'Produsul ales' : v.title}`;
        const amount = document.createElement('div');
        this.renderPrice(amount, (v?.price || 0) * qty, Math.max(v?.price || 0, v?.compare || 0) * qty, qty > 1 ? `la ${qty} buc.` : '/ buc.');
        li.append(title, amount); lines.append(li);
      }
      if (!s.main.size) {
        const li = document.createElement('li'); li.textContent = 'Alege mai sus nuanța și cantitatea dorită.'; lines.append(li);
      }
      this.querySelector('[data-set-total]').textContent = s.valid ? (s.shades && !s.extras.size ? 'Nuanțele sunt deja în coș. Alege un produs opțional sau finalizează comanda din coș.' : `${s.count} ${s.count === 1 ? 'bucată selectată' : 'bucăți selectate'} · ${s.main.size + s.extras.size} ${s.main.size + s.extras.size === 1 ? 'variantă' : 'variante'}`) : 'Adaugă mai întâi nuanțele în coș.';
      this.querySelector('[data-set-main-total]').textContent = s.valid ? this.money(s.mainTotal) : '—';
      this.querySelector('[data-set-extras-total]').textContent = s.valid ? this.money(s.extrasTotal) : '—';
      this.querySelector('[data-set-grand-total]').textContent = s.valid ? this.money(s.total) : '—';
      const saving = Math.max(0, s.list - s.total);
      const showSaving = s.valid && s.list > 0 && saving > 0;
      for (const el of this.querySelectorAll('[data-set-savings-row]')) el.hidden = !showSaving;
      const reference = this.querySelector('[data-set-reference]');
      const reduction = this.querySelector('[data-set-product-saving]');
      if (reference) reference.textContent = showSaving ? this.money(s.list) : '';
      if (reduction) reduction.textContent = showSaving ? `−${this.money(saving)} (−${new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 1 }).format(saving / s.list * 100)}%)` : '';

    }

    async add() {
      const s = this.selection();
      if (!s.valid || this.busy || this.locked) return;
      if (!window.PBCroCart) { this.message.textContent = 'Coșul nu este disponibil acum. Reîncarcă pagina.'; return; }
      this.busy = true; this.update();
      let result;
      try {
        if (s.shades) result = await window.PBCroCart.add(s.extras);
        else {
          const items = new Map(s.main);
          for (const [id, qty] of s.extras) items.set(id, (items.get(id) || 0) + qty);
          result = await window.PBCroCart.add(items);
        }
        if (result?.complete) {
          window.PBCroAnalytics?.emit('set_add', { product_id: this.dataset.product, items_added: (s.shades ? [...s.extras.values()] : [...s.main.values(), ...s.extras.values()]).reduce((n,q)=>n+q,0), value: (s.shades ? s.extrasTotal : s.total) / 100 });
          this.message.textContent = s.shades ? 'Produsele opționale au fost adăugate în coș.' : 'Produsele selectate au fost adăugate în coș.';
        } else {
          // A partially accepted request must never be submitted as the whole set again.
          this.locked = true;
          this.message.textContent = result?.unavailable ? 'Coșul nu este disponibil acum. Reîncarcă pagina.' : 'Nu s-a putut confirma întregul set. Verifică produsele din coș și reîncarcă pagina înainte de a încerca din nou.';
        }
      } catch (_) {
        this.locked = true;
        this.message.textContent = 'Verifică produsele din coș și reîncarcă pagina înainte de a încerca din nou.';
      }
      this.busy = false; this.update();
    }
  }
  customElements.define('pb-cro-set', ProductSet);
})();

}
